import { render, staticRenderFns } from "./SitesListPage.vue?vue&type=template&id=4fd6c81e&"
import script from "./SitesListPage.vue?vue&type=script&lang=ts&"
export * from "./SitesListPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports